import React, { useState } from 'react'
import toast from 'react-hot-toast'
import { FaEye } from "react-icons/fa";
import { FaEyeSlash } from "react-icons/fa";
import { Link, useNavigate } from 'react-router-dom';
import FullScreenLoader from './FullScreenLoader';
import Footer from './Footer';

const SingUp = () => {
  const [view, setView] = useState(false)
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const BASE_URl = window.location.origin

  const handleSingUp = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    
    formData.append("name", e.target.name.value);
    formData.append("email", e.target.email.value);
    formData.append("password", e.target.password.value);
    formData.append("image", e.target.file.files[0]); // ✅ Use files[0] instead of value
  
    setLoading(true)
    fetch(`${BASE_URl}/api/singup`, {
      method: "POST",
      credentials: "include",
      body: formData, // ✅ No need to set headers manually
    })
      .then((res) => res.json())
      .then((data) => {
        if (data && data.sucess === true) {
          setLoading(false)
          toast.success(data.messege);
          navigate("/auth/verifycode");
        } else if (data && data.sucess === false) {
          setLoading(false)
          toast.error(data.messege);
        }
      })
      .catch((error) => {
        setLoading(false)
        toast.error(error.messege || "Internal Server Error");
      });
  
    e.target.reset();
  };
  


  return (
    <>
    <div className='mt-20 flex flex-col items-center h-[100vh] pb-14'>
      <h1 className='text-center mb-8 text-3xl font-serif'>Register Now</h1>
      {loading?<FullScreenLoader/>:null}
      <form onSubmit={handleSingUp} className='flex flex-col items-center justify-evenly gap-2 w-[90%] h-[100%] bg-blue-300 p-3 rounded-[10px] sm:w-[80%] lg:w-[70%]'>
        <input required type="text" placeholder='Your Name' name="name" className='border-[0.5px] p-2 outline-0 rounded-[8px] w-[80%] active:bg-none focus:bg-none placeholder:text-black '/>
        <div className='w-[80%] flex flex-col items-start gap-1'>
          <p className=' font-bold'>Profile Image</p>
        <input required type="file" placeholder='Your Profile Image' name="file" className='border-[0.5px] p-2  rounded-[8px] w-[100%] '/>
        </div>
        <input required type="email" placeholder='Your Email' name="email" className='border-[0.5px] p-2 outline-0 rounded-[8px] w-[80%] active:bg-none placeholder:text-black '/>
        <div className='w-[80%] flex items-center'>
            <input required type={view?'text':'password'} placeholder='Your Password' name="password" className=' p-2 outline-0 w-[100%] active:bg-none placeholder:text-black ' style={{borderLeft: '0.5px solid black', borderTop: '0.5px solid black', borderBottom: '0.5px solid black', borderTopLeftRadius: '8px', borderBottomLeftRadius: '8px'}}/>
            <span onClick={()=>{setView(!view)}} className='cursor-pointer p-2 text-2xl' style={{borderRight: '0.5px solid black', borderTop: '0.5px solid black', borderBottom: '0.5px solid black', borderTopRightRadius: '8px', borderBottomRightRadius: '8px'}}>{view?<FaEyeSlash/>:<FaEye/>}</span>
        </div>
        <div className='w-[80%] flex justify-evenly'>
          <button type='reset' className='cursor-pointer border-[0.5px] p-3 rounded-2xl hover:bg-blue-200' style={{transition: '0.5s'}}>Reset</button>
          <button type='submit' className='cursor-pointer border-[0.5px] p-2 rounded-2xl bg-blue-200 hover:bg-blue-300' style={{transition: '0.5s'}}>Register</button>
        </div>
        <p>Already have Account ? <Link to="/auth/login">Login here</Link></p>
      </form>

    </div>
    <Footer/>
    </>
  )
}

export default SingUp
 